export default "<p>payment-channels-providers works!</p>\n";